/**
 * gw-cart — las piezas del cajón propio de Genwell (sin Corner).
 *
 * 1. Suscripción por renglón (snippets/gw-cart-sub.liquid): el interruptor y la
 *    frecuencia cambian el plan con /cart/change.js + selling_plan (null =
 *    compra única). Kaching Subscriptions usa los planes nativos de Shopify.
 * 2. «Suscribirme» del aviso (snippets/gw-cart-sub-aviso.liquid): pasa al
 *    primer plan todo lo que se puede suscribir, una llamada por renglón.
 * 3. «Agregar» de los recomendados (snippets/gw-cart-reco-card.liquid).
 * 4. <gw-cart-panel> en automático: pide a Shopify los relacionados y los
 *    pinta con sections/gw-cart-recos.liquid.
 *
 * Después de cada cambio se repinta .drawer__inner con la sección cart-drawer,
 * igual que el tema cuando cambia una cantidad. Los oyentes van delegados en
 * document porque el cajón se vuelve a pintar entero en cada cambio.
 *
 * OJO: cart-drawer-items (assets/cart.js) trata CUALQUIER «change» de adentro
 * como cambio de cantidad. Por eso los «change» de la suscripción se atrapan
 * en captura y no siguen subiendo.
 */
(function () {
  if (window.gwCartReady) return;
  window.gwCartReady = true;

  var SECCIONES = 'cart-drawer,cart-icon-bubble';

  function rutas() {
    var r = window.routes || {};
    return {
      add: r.cart_add_url || '/cart/add',
      change: r.cart_change_url || '/cart/change',
      root: (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/',
    };
  }

  function config(body) {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    };
  }

  function parse(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  /** Repinta el cajón y la burbuja con lo que regresó Shopify. */
  function pintar(sections) {
    if (!sections) return;
    var html = sections['cart-drawer'];
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (html && inner) {
      var nuevo = parse(html, '.drawer__inner');
      if (nuevo) inner.innerHTML = nuevo.innerHTML;
    }
    var burbuja = document.getElementById('cart-icon-bubble');
    if (sections['cart-icon-bubble'] && burbuja) {
      var b = parse(sections['cart-icon-bubble'], '.shopify-section');
      if (b) burbuja.innerHTML = b.innerHTML;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.remove('is-empty');
  }

  function avisar(cartData) {
    // source «cart-items»: el tema ya no vuelve a pedir el cajón (ya está
    // pintado), pero los demás oyentes (códigos de descuento, etc.) sí se enteran.
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cartData });
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
  }

  function error(mensaje) {
    var caja = document.getElementById('CartDrawer-CartErrors');
    if (caja) caja.textContent = mensaje || (window.cartStrings && window.cartStrings.error) || 'Algo salió mal. Intenta de nuevo.';
  }

  function ocupado(si) {
    var items = document.querySelector('cart-drawer-items');
    if (items) items.classList.toggle('gw-ocupado', si);
  }

  function falla(data, res) {
    return !res.ok || (data && (data.status || data.errors));
  }

  /* ── 1. Suscripción por renglón ─────────────────────────────────────── */

  function cambiarPlan(root, plan, revertir) {
    var filas = Array.prototype.slice.call(document.querySelectorAll('#CartDrawer .cart-item'));
    var fila = root.closest('.cart-item');
    var pos = filas.indexOf(fila);

    root.setAttribute('aria-busy', 'true');
    ocupado(true);

    return fetch(rutas().change, config({
      id: root.dataset.key,
      quantity: Number(root.dataset.quantity),
      selling_plan: plan ? Number(plan) : null,
      sections: SECCIONES,
      sections_url: window.location.pathname,
    }))
      .then(function (res) {
        return res.json().then(function (data) {
          if (falla(data, res)) throw new Error(data.description || data.message || data.errors || '');
          pintar(data.sections);
          avisar(data);
          // El foco regresa al interruptor del mismo renglón.
          var nuevas = document.querySelectorAll('#CartDrawer .cart-item');
          var sw = nuevas[pos] && nuevas[pos].querySelector('.gw-sub__switch');
          if (sw) sw.focus({ preventScroll: true });
        });
      })
      .catch(function (e) {
        console.error('gw-cart:', e);
        revertir();
        root.removeAttribute('aria-busy');
        error(e && e.message);
      })
      .finally(function () {
        ocupado(false);
      });
  }

  document.addEventListener(
    'change',
    function (event) {
      var t = event.target;
      if (!(t instanceof HTMLElement)) return;
      var root = t.closest('[data-gw-sub]');
      if (!root) return;

      // Que no llegue a cart-drawer-items: lo tomaría como cambio de cantidad.
      event.stopPropagation();
      if (root.getAttribute('aria-busy') === 'true') return;

      if (t.classList.contains('gw-sub__switch')) {
        var prendido = t.checked;
        cambiarPlan(root, prendido ? root.dataset.plan : null, function () {
          t.checked = !prendido;
        });
      } else if (t.classList.contains('gw-sub__select')) {
        var anterior = '';
        for (var i = 0; i < t.options.length; i++) {
          if (t.options[i].defaultSelected) anterior = t.options[i].value;
        }
        cambiarPlan(root, t.value, function () {
          t.value = anterior;
        });
      }
    },
    true
  );

  /* ── 2. «Suscribirme»: todo de un jalón ─────────────────────────────── */

  function suscribirTodo(btn) {
    var aviso = btn.closest('[data-gw-sub-aviso]');
    var lineas = ((aviso && aviso.dataset.lineas) || '').split(',').filter(Boolean);
    if (!lineas.length) return;

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    ocupado(true);

    var cadena = Promise.resolve();
    var fallo = null;
    lineas.forEach(function (l) {
      var partes = l.split('|');
      cadena = cadena.then(function () {
        return fetch(rutas().change, config({
          id: partes[0],
          selling_plan: Number(partes[1]),
          quantity: Number(partes[2]),
        }))
          .then(function (res) {
            return res.json().then(function (data) {
              if (falla(data, res)) fallo = data.description || data.message || '';
            });
          })
          .catch(function (e) {
            fallo = e && e.message;
          });
      });
    });

    return cadena
      .then(function () {
        return fetch(window.location.pathname + '?sections=' + SECCIONES).then(function (r) {
          return r.json();
        });
      })
      .then(function (sections) {
        pintar(sections);
        return fetch(rutas().root + 'cart.js').then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        avisar(cart);
        if (fallo !== null) error(fallo);
      })
      .catch(function (e) {
        console.error('gw-cart:', e);
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        error(e && e.message);
      })
      .finally(function () {
        ocupado(false);
      });
  }

  /* ── 3. «Agregar» de los recomendados ───────────────────────────────── */

  function agregar(btn) {
    var texto = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Agregando…';

    return fetch(rutas().add, config({
      items: [{ id: Number(btn.dataset.gwRecoAdd), quantity: 1 }],
      sections: SECCIONES,
      sections_url: window.location.pathname,
    }))
      .then(function (res) {
        return res.json().then(function (data) {
          if (falla(data, res)) throw new Error(data.description || data.message || '');
          pintar(data.sections);
          avisar(data);
          var titulo = document.querySelector('#CartDrawer .cart-item__name');
          if (titulo) titulo.focus({ preventScroll: true });
        });
      })
      .catch(function (e) {
        console.error('gw-cart:', e);
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = texto;
        error(e && e.message);
      });
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!(t instanceof HTMLElement)) return;

    var add = t.closest('[data-gw-reco-add]');
    if (add) {
      event.preventDefault();
      if (add.getAttribute('aria-busy') !== 'true') agregar(add);
      return;
    }

    var todo = t.closest('[data-gw-sub-todo]');
    if (todo) {
      event.preventDefault();
      if (todo.getAttribute('aria-busy') !== 'true') suscribirTodo(todo);
    }
  });

  /* ── 4. Panel automático ────────────────────────────────────────────── */

  var cache = new Map(); // product_id → [{id, html}]
  var pendientes = new Map(); // product_id → Promise

  function cargar(id) {
    if (cache.has(id)) return cache.get(id);
    if (pendientes.has(id)) return pendientes.get(id);
    var url =
      rutas().root +
      'recommendations/products?product_id=' + encodeURIComponent(id) +
      '&limit=10&intent=related&section_id=gw-cart-recos';
    var p = fetch(url)
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        var lista = [];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('li.gw-cp__item').forEach(function (li) {
            lista.push({ id: li.dataset.productId, clave: li.dataset.clave || '', html: li.outerHTML });
          });
        }
        cache.set(id, lista);
        pendientes.delete(id);
        return lista;
      })
      .catch(function () {
        // Vacío en caché: si Shopify falla, no se vuelve a pedir en bucle.
        cache.set(id, []);
        pendientes.delete(id);
        return [];
      });
    pendientes.set(id, p);
    return p;
  }

  class GwCartPanel extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-auto')) this.llenar();
    }

    llenar() {
      var self = this;
      var ids = (this.dataset.products || '').split(',').filter(Boolean).slice(0, 3);
      var excluir = new Set((this.dataset.exclude || '').split(',').filter(Boolean));
      // Nombre, subtítulo y componentes de lo que ya está en el carrito: un
      // recomendado que viene dentro de un kit del carrito tampoco sale.
      var contenido = this.dataset.contenido || '';
      var max = Number(this.dataset.max) || 4;
      var elegidos = new Map();

      function juntar(lista) {
        lista.forEach(function (x) {
          if (elegidos.size >= max || excluir.has(x.id) || elegidos.has(x.id)) return;
          if (x.clave && contenido.indexOf(x.clave) !== -1) return;
          elegidos.set(x.id, x.html);
        });
      }

      function pintarLista() {
        if (!self.isConnected) return;
        var ul = self.querySelector('[data-gw-cp-list]');
        if (!ul || elegidos.size === 0) {
          self.hidden = true;
          return;
        }
        ul.innerHTML = Array.from(elegidos.values()).join('');
        self.hidden = false;
      }

      // Si todo está en caché se pinta en el mismo tick (sin parpadeo al
      // repintar el cajón); si no, en cuanto llegue.
      var i = 0;
      (function siguiente() {
        while (i < ids.length && elegidos.size < max) {
          var c = cache.get(ids[i]);
          if (!c) {
            cargar(ids[i]).then(function () {
              siguiente();
            });
            return;
          }
          juntar(c);
          i++;
        }
        pintarLista();
      })();
    }
  }

  if (!customElements.get('gw-cart-panel')) customElements.define('gw-cart-panel', GwCartPanel);
})();
